"use strict";

import { AjaxCall, basicRetryPolicy, getHttpDetails, isHttpRetry } from 'api/basicApi';
import { WalletCheckExpiration } from 'api/walletAPICall'; // Ewww HACKY !

// re export
export { getHttpDetails, isHttpRetry, basicRetryPolicy };


////////////////////////////////////////////
// class GenericAPICall
export class GenericAPICall  extends AjaxCall {


  constructor ( command )  {
    super( command )

    const { token } = SettingsInjections.getCredentials();

    this.append( "action", command );
    this.append( "token", token );
  }


  preRequestHook()  {   //override
    return WalletCheckExpiration( false );
  }
};

